import { listOrgApiMetrics, getApiHealthSummary } from "./apiMetricsHelpers"
import { listOrgWebhookDeliveries } from "./webhookHelpers"

export const computeDeveloperHealth = async (orgId) => {
  const [{ metrics }, apiHealth7d, { deliveries }] = await Promise.all([
    listOrgApiMetrics(orgId),
    getApiHealthSummary(orgId, 7),
    listOrgWebhookDeliveries(orgId),
  ])

  const totalRequests = metrics?.reduce((sum, m) => sum + (m?.requests || 0), 0) || 0
  const hasApiActivity = totalRequests > 0

  const delivered = deliveries?.filter((d) => d?.status === "success")?.length || 0
  const failed = deliveries?.filter((d) => d?.status === "failed")?.length || 0
  const totalDeliveries = delivered + failed
  const hasWebhookActivity = totalDeliveries > 0

  return {
    apiRequests: { total: totalRequests, tracked: hasApiActivity },
    successRate: { value: hasApiActivity ? Math.round((1 - apiHealth7d?.errorRate / 100) * 1000) / 10 : null, tracked: hasApiActivity },
    webhooksDelivered: { total: delivered, tracked: hasWebhookActivity },
    errorRate: { value: apiHealth7d?.errorRate || 0, tracked: hasApiActivity },
  }
}